module.exports = __webpack_public_path__ + "media/src/images/arrow_down_gy_on-abfa9cbb0d598db1f9aa4e8e5227ce9f.png";